// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__9Fezt","mainContent":"DashboardLayout_mainContent__+5rg4","content":"DashboardLayout_content__OpBw5"};